import { AbjadHebrewIcon } from './AbjadHebrewIcon';

/**
 * author: Haley Halcyon
 * id FC508376-0233-498A-ABF8-B289241031FF
 * name abjad-hebrew
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/abjad-hebrew.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemHebrewIcon = AbjadHebrewIcon;
export default WritingSystemHebrewIcon